var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExplanation(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "13px",
    viewBox: "0 0 13 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 0,
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Payroll-icons",
    transform: "translate(-641.000000, -338.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(641.000000, 338.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#595959",
    fill: "#595959",
    cx: 6.5,
    cy: 6.5,
    r: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.6,7.99 C6.73333333,7.99 6.81666667,7.91 6.85,7.75 C6.85,7.65666667 6.85666667,7.51666667 6.87,7.33 C6.89,7.09666667 6.96333333,6.885 7.09,6.695 C7.21666667,6.505 7.40666667,6.27333333 7.66,6 C7.96666667,5.67333333 8.19666667,5.38666667 8.35,5.14 C8.50333333,4.89333333 8.58,4.6 8.58,4.26 C8.58,3.96 8.5,3.675 8.34,3.405 C8.18,3.135 7.93333333,2.91666667 7.6,2.75 C7.26666667,2.58333333 6.85666667,2.5 6.37,2.5 C5.91,2.5 5.50166667,2.59166667 5.145,2.775 C4.78833333,2.95833333 4.51166667,3.205 4.315,3.515 C4.11833333,3.825 4.01333333,4.16333333 4,4.53 C4,4.59666667 4.02166667,4.65 4.065,4.69 C4.10833333,4.73 4.16,4.75 4.22,4.75 L4.22,4.75 L4.66,4.75 C4.80666667,4.75 4.89333333,4.67666667 4.92,4.53 C4.99333333,4.11 5.155,3.80166667 5.405,3.605 C5.655,3.40833333 5.96666667,3.31 6.34,3.31 C6.68666667,3.31 6.99,3.4 7.25,3.58 C7.51,3.76 7.64,4.00333333 7.64,4.31 C7.64,4.37 7.63666667,4.41333333 7.63,4.44 C7.61,4.62666667 7.54166667,4.8 7.425,4.96 C7.30833333,5.12 7.13,5.32333333 6.89,5.57 C6.57666667,5.89 6.335,6.18 6.165,6.44 C5.995,6.7 5.90333333,7.00666667 5.89,7.36 L5.89,7.36 L5.89,7.77 C5.89,7.83666667 5.91,7.89 5.95,7.93 C5.99,7.97 6.04333333,7.99 6.11,7.99 L6.11,7.99 L6.6,7.99 Z M6.84,10 C6.90666667,10 6.96333333,9.97833333 7.01,9.935 C7.05666667,9.89166667 7.08,9.83666667 7.08,9.77 L7.08,9.77 L7.08,9.19 C7.08,9.12333333 7.05666667,9.06666667 7.01,9.02 C6.96333333,8.97333333 6.90666667,8.95 6.84,8.95 L6.84,8.95 L6.22,8.95 C6.15333333,8.95 6.09833333,8.97333333 6.055,9.02 C6.01166667,9.06666667 5.99,9.12333333 5.99,9.19 L5.99,9.19 L5.99,9.77 C5.99,9.83666667 6.01166667,9.89166667 6.055,9.935 C6.09833333,9.97833333 6.15333333,10 6.22,10 L6.22,10 L6.84,10 Z",
    id: "?",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplanation);
export default __webpack_public_path__ + "static/media/explanation.79a722f8.svg";
export { ForwardRef as ReactComponent };